import React from "react";
import { useTranslation } from 'react-i18next';
import ElmaliCosmosBeige from "../Components/quarries/ElmaliCosmosBeige";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";
import productSeoData from "../data/productSeoData.json";

function ElmaliCosmosBeigePage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = productSeoData[currentLang]?.cosmosBeige || productSeoData.en.cosmosBeige;

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/elmalicosmosbeige"
        image={seo.image}
        structuredData={seo.structuredData}
      />
      <TopBar />
      <Spacer/>
      <ElmaliCosmosBeige />
    </>
  );
}

export default ElmaliCosmosBeigePage;
